import type { BaseBlog } from '@bulknutrients/bulk-shared-lib/interfaces/Blog';
import type { BaseProduct } from '@bulknutrients/bulk-shared-lib/interfaces/Product';
import { BlogCard } from '@components/Blog/BlogCard';
import { EmblaCarousel } from '@components/Carousels/Carousel';
import { ProductCard } from '@components/ProductCard/ProductCard';
import type { PortableTextTypeComponentProps } from '@portabletext/react';

interface CarouselProps {
  _type: string;
  _key: string;
  items: Array<BaseBlog | BaseProduct>;
}

function isProductCarousel(item: BaseBlog | BaseProduct): item is BaseProduct {
  return (item as BaseProduct).sku !== undefined;
}

export function CarouselRenderer(
  props: PortableTextTypeComponentProps<CarouselProps>
) {
  if (isProductCarousel(props.value.items[0])) {
    return (
      <div className="light-background full-bleed my-5">
        <EmblaCarousel
          slides={props.value.items.map((item) => {
            return (
              <ProductCard
                product={item as BaseProduct}
                key={(item as BaseProduct).entityId}
                location="CarouselRenderer from portableText"
              />
            );
          })}
        />
      </div>
    );
  }
  return (
    <div className="light-background full-bleed my-5">
      <EmblaCarousel
        slides={props.value.items.map((item) => (
          <BlogCard blog={item as BaseBlog} key={item.slug} />
        ))}
      />
    </div>
  );
}
